import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  StyledEmployerDirectory,
  StyledEmployerCompleteName,
  StyledEmployerLastName,
  StyledEmployerEmail,
  StyledEmployerTableCellDate,
  StyledEmployerTableCellIssue,
  StyledEmployerTableCellEmailSended,
  IconButtonChecked
} from './style';

import { Check, Close } from '../../../../assets/images/index';

class RowDirectoryWithholding extends Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.state = { active: false };
  }

  onClick() {
    const { active } = this.state;
    const {
      row,
      dataRow,
      rowSelected,
      setRowSelected,
      setEmployeeSelected
    } = this.props;
    this.setState({ active: !active });

    if (row !== rowSelected) {
      setRowSelected(row);
      setEmployeeSelected({
        text: `${dataRow.name} ${dataRow.lastname}`,
        value: dataRow.userId
      });
    }
  }

  render() {
    const { dataRow, row, rowSelected } = this.props;
    const { active } = this.state;
    return (
      <StyledEmployerDirectory
        active={active}
        row={row}
        rowSelected={rowSelected}
        onClick={this.onClick}
      >
        <StyledEmployerCompleteName title={dataRow.nombre}>
          {' '}
          {dataRow.nombre}{' '}
        </StyledEmployerCompleteName>
        <StyledEmployerLastName title={dataRow.apellido1}>
          {' '}
          {`${dataRow.apellido1} ${dataRow.apellido2}`}{' '}
        </StyledEmployerLastName>
        <StyledEmployerTableCellDate title={dataRow.dni}>
          {' '}
          {dataRow.dni}{' '}
        </StyledEmployerTableCellDate>
        <StyledEmployerEmail title={dataRow.email}>
          {' '}
          {dataRow.email}{' '}
        </StyledEmployerEmail>
        <StyledEmployerTableCellDate title={dataRow.fecha}>
          {' '}
          {dataRow.fecha}{' '}
        </StyledEmployerTableCellDate>
        <StyledEmployerTableCellIssue title={dataRow.motivo}>
          {dataRow.motivo}
        </StyledEmployerTableCellIssue>
        <StyledEmployerTableCellDate title={dataRow.year}>
          {dataRow.year}
        </StyledEmployerTableCellDate>
        <StyledEmployerTableCellEmailSended title={dataRow.enviado}>
          <IconButtonChecked
            svg={dataRow.enviado === true ? Check : Close}
            size="s"
          />
        </StyledEmployerTableCellEmailSended>
      </StyledEmployerDirectory>
    );
  }
}

RowDirectoryWithholding.propTypes = {
  dataRow: PropTypes.shape({
    userId: PropTypes.number,
    name: PropTypes.string,
    lastname: PropTypes.string,
    profile: PropTypes.string,
    department: PropTypes.string,
    extension: PropTypes.number,
    phones: PropTypes.string,
    email: PropTypes.string
  })
};

export default RowDirectoryWithholding;
